import { cardsItems } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">片单精选</h2>
          <p className="text-sm text-foreground-600">编辑团队精心挑选，每一部都值得在春夜细细品味</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsItems.slice(0, 1).map((item) => (
            <div key={item.id} className="group rounded-2xl overflow-hidden bg-background-100 transition-all duration-300 sm:col-span-2 lg:col-span-2">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 h-56 lg:h-72">
                  <div className="relative w-full h-full">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                  </div>
                </div>
                <div className="lg:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 mb-3 self-start whitespace-nowrap">{item.tag}</span>
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="text-lg md:text-xl font-heading text-foreground-950">{item.title}</h3>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.rating} 分</span>
                  </div>
                  <p className="text-xs text-foreground-500 mb-3">{item.subtitle}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
          {cardsItems.slice(1).map((item) => (
            <div key={item.id} className="group rounded-2xl overflow-hidden bg-background-100 transition-all duration-300">
              <div className="h-48 overflow-hidden">
                <div className="relative w-full h-full">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">{item.tag}</span>
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-base font-heading text-foreground-950">{item.title}</h3>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.rating} 分</span>
                </div>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}